<template>
  <div>
    <h4>數學科</h4>
    <dl>
      <dt>資優數學班</dt>
      <dd>
        資優班適合公立學校學生，超前學校教學進度，多做複習，打好基礎，穩固會考堅強實力！
      </dd>

      <dt>私校數學班（另設明道、曉明專班）</dt>
      <dd>
        私立學校數學科進度與公立學校不同，想好好配合私校進度，不想打亂了學習的步調，就來私校數學班吧！
      </dd>

      <dt>菁英數學班</dt>
      <dd>
        菁英班適合成績中上學生、私立學校學生等，學習加深、加廣，上課可以配合進度較快的私校，教材難度up！
      </dd>

      <dt>拔尖數學班 （需經甄試入班）</dt>
      <dd>
        拔尖班適合資質優異學生，穩紮穩打的數學訓練，以及額外使用更深入的數學教材，培養深厚數學實力，未來考慮報考高中科學班、數資班等特殊班！
      </dd>
    </dl>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/scss/course.scss";
</style>
